<script>
export default {
  name: "TheFacultyStatisticsTable",

  props : {
    statistics: Array,
    departmentName: String,
  }
}
</script>

<template>
  <v-simple-table>
    <template v-slot:default>
      <thead :style="{'height': '100px'}">
      <tr>
        <th rowspan="3">Курс</th>
        <th rowspan="3">Кол-во аттестуемых, чел.</th>
        <th colspan="2" rowspan="2">Аттестовано</th>
        <th colspan="5" class="text-center">Не аттестовано</th>
      </tr>
      <tr>
        <th colspan="2">Всего</th>
        <th colspan="3">в том числе по кол-ву дисциплин, чел.</th>
      </tr>
      <tr>
        <th>чел.</th>
        <th>%</th>
        <th>чел.</th>
        <th>%</th>
        <th>одной</th>
        <th>двум</th>
        <th>трем и более</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="statistic in statistics" :key="`${departmentName}-${statistic.course}`">
          <td>{{statistic.course}}</td>
          <td>{{statistic.size}}</td>
          <td>{{statistic.attestStudentsCount}}</td>
          <td>{{statistic.attestStudentsPercent}} %</td>
          <td>{{statistic.notAttestStudentsCount}}</td>
          <td>{{statistic.notAttestStudentsPercent}} %</td>
          <td>{{statistic.notAttestOneDisciplineCount}}</td>
          <td>{{statistic.notAttestTwoDisciplineCount}}</td>
          <td>{{statistic.notAttestThreeAndMoreDisciplineCount}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<style scoped>

</style>